module.exports = "<ng-template #contentTemplate>\r\n    <ng-content></ng-content>\r\n    <tooltip *ngIf=\"tooltip\">\r\n        {{tooltip}}\r\n    </tooltip>\r\n</ng-template>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client-src/app/core/components/toolbar/nested/item/toolbar-item.nested.html
// module id = ./client-src/app/core/components/toolbar/nested/item/toolbar-item.nested.html
// module chunks = main